import React from 'react';
import { getBackgroundPicture } from 'components/VerticalVideo/utils';
import styles from './styles.module.scss';

/**
 * VideoThumbnail component displays a thumbnail for a video with a fallback image if the thumbnail is not available.
 * @param {object} props
 * @param {object} props.video
 */
export const VideoThumbnail = ({ video = {} }) => {
  const { computedValues = {} } = video;

  return (
    <div className={styles.videoThumbnail}>
      <img src={getBackgroundPicture(computedValues)} alt="video-thumbnail" />
    </div>
  );
};
